import { Component, Input, OnInit, EventEmitter, Output, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'mt-common-form',
    templateUrl: './form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormComponent implements OnInit, OnChanges {
  @Input() postObj: any = {};
  @Input() formFields: any[];
  @Input() formHeader: string;
  @Input() buttons: any[];
  @Input() label: boolean = true
  // TODO remove cols --unnecessary allocation
  @Input() cols: number;
  @Input() editForm: boolean;
  @Output() onAction = new EventEmitter<any>();
  @Output() onCloseAction = new EventEmitter<any>();
  @Input() btnClass: boolean = false;
  @Input() multiple?: boolean;
  @Output() onTreeselect = new EventEmitter<any>();
  inputFieldCount: number = 0; // Start with 1 input fields

  queryRow = 3;

  frmField: any = {
    updateChildInput: false
  };
  copyFormFields: any = [];

  showCallerIdInput: boolean = false;
  showImage: boolean = false;
  imgSource: string = ""

  constructor() {}

  ngOnChanges() {
    this.postObj.relations = [{}];  
  }

  ngOnInit(): void {
    this.copyFormFields = JSON.parse(JSON.stringify(this.formFields));
    this.postObj.relations = [{}];
  }

  ngOnDestroy() {
    // TODO analyse this code --no-trigger-found --priority-low
    if (
      this.frmField.updateChildInput &&
      this.frmField.childModel &&
      Object.keys(this.frmField.resetChildModelKeys).length > 0
    ) {
      this.formFields.forEach((field: any) => {
        if (field['model'] === this.frmField.childModel) {
          Object.keys(this.frmField.resetChildModelKeys).forEach(key => {
            // field[key] = this.frmField.updatedChildModeKeys['0']
            field[key] = this.frmField.resetChildModelKeys[key];
          });
        }
      });
      this.showCallerIdInput = true;
    }
  }

    onDropDownChange(formField, index, event?: any) {
      console.log("$formField", formField);
      console.log("$event", event);

      if(formField.name == 'Trees') {   
        this.onTreeselect.emit(event.value)
      }
      this.frmField = formField;
      if (formField.updateChildInput && formField.childModel && Object.keys(formField.updatedChildModelKeys).length > 0) {
        this.formFields.forEach((field: any) => {
          if (field['model'] === formField.childModel) {
            Object.keys(formField.updatedChildModelKeys).forEach(key => {
              field[key] = formField.updatedChildModelKeys[key];
            });
          }
        });
      }
      if(formField.method === "getUserBasedOnFunction") {
        const optionValue = formField.options.filter(option => {
          return option.id === this.postObj.user;
        })
        this.imgSource = optionValue[0].sign;
      }
    }

    addnewRelation() {
      this.inputFieldCount += 1; // Add 1 input fields at a time 
      this.postObj.relations.push({});
    }

    removeLastRelations() {
     if(this.postObj.relations && this.postObj.relations.length >1){
      this.postObj.relations.pop();
     }
    }

    onSelectAll(e: any) {
      this.onAction.emit(this.postObj);
    }

  onFormAction(flag,value ) {
    if(value === 'reset') { 
      this.postObj = {};
      this.showImage = false;
    }  else {
      this.postObj.sign = this.imgSource;
      this.onAction.emit({ flag, value, formValue: this.postObj});
    }
  }

  getBtnLabel(btn) {
    return this.editForm ? btn.modify.name : btn.name;
  }

  inputChange(formFields) {

  }
  onClose(flag){
    this.onCloseAction.emit(flag);
  }
}
